























































































import {Component, Prop, Model} from 'vue-property-decorator';
import CommonVue from '../models/commonVue';
import {BusEvent} from '@/models/bus';

import Phoneme from '../api/phoneme';

import Modal from '@/components/Modal.vue';
import FieldHints from '../components/FieldHints.vue';
import FieldAudio from '@/components/FieldAudio.vue';
import FieldTextRange from '../components/FieldTextRange.vue';
import EditIcon from '../components/icons/EditIcon.vue';

@Component({
    components: {
        'modal': Modal,
        'field-audio': FieldAudio,
        'edit-icon': EditIcon,
        'field-hints': FieldHints,
        'field-text-range': FieldTextRange,
    },
})
export default class FieldPhonemes extends CommonVue {
    @Model() public phonemes!: Phoneme[];

    @Prop({type: String}) public sentence!: string;

    @Prop({type: Boolean, default: false}) public disabled?: boolean;

    public phoneme: Phoneme = null;
    public showModal: boolean = false;
    
    public newPhoneme() {
        this.phoneme = new Phoneme();
        this.showModal = true;
    }
    
    public edit(phoneme: Phoneme) {
        this.phoneme = phoneme;
        this.showModal = true;
    }
    
    public saveClicked() {
        if (!this.phoneme) {
            return;
        }
        
        this.busy = true;
        
        try {
            this.checkMandatoryFields();
            if (this.phoneme.state === 'created') {
                this.phonemes.push(this.phoneme);
            }
            this.phoneme.state = 'updated';
            this.busy = false;
            this.showModal = false;
        } catch (e) {
            this.busy = false;
            this.$bus.$emit(BusEvent.ERROR, 'Could not save phoneme', e);
        }
    }
    
    public checkMandatoryFields() {
        // Check if start index is filled
        if(this.phoneme.start_index === undefined || this.phoneme.start_index === -1) {
            throw Error('Please select a range for your phoneme.');
        }

        // Check if end index is filled
        if(this.phoneme.end_index === undefined || this.phoneme.end_index === -1) {
            throw Error('Please select a range for your phoneme.');
        }
    }
    
    public deleteClicked() {
        this.phoneme.state = 'deleted';
        this.showModal = false;
    }
}
